import { buildViewerLink } from './build-viewer-link';
import { useLsproFeatures } from '../manager/providers/lspro-features';

type SharingLinkLike =
  | {
      sharingUrl?: string | null;
      token?: string | null;
    }
  | null
  | undefined;

export function useViewerLink(sharingLink: SharingLinkLike): string {
  const { customDomainsEnabled } = useLsproFeatures();
  return buildViewerLink(sharingLink, customDomainsEnabled);
}
